import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { useAssets } from "../assets/AssetsContext";
import ClientLogoSlider from "./ClientLogoSlider";

import { Link } from "react-router-dom";

function Blogs() {
  const assets = useAssets();

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
    });
    AOS.refresh();
  }, []);

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  const blogs = [
    /*{
      id: 1,
      title: "Voices from the Frontier of Climate Innovation",
      subtitle: "y admin | June 01, 2025 | Blog | 0 comments",
      image: assets.blogthumb1a,
      description:
        "Dive into stories, breakthroughs, and bold ideas shaping the future of sustainability. From regenerative...",
    },*/
    {
      id: 2,
      title:
        "Listed Companies Turn to AccelTRACK for Cutting-Edge ESG Reporting and Compliance Solutions",
      subtitle: "by admin | Oct 22, 2024 | Blog",
      image: assets.blogthumb1,
      description:
        "As the demand for environmental, social, and governance (ESG) transparency rises, listed companies across industries...",
    },
    {
      id: 3,
      title:
        "Australia Passes Landmark Climate Disclosure Legislation and Establishes Net Zero Economy Authority",
      subtitle: "by admin | Sep 10, 2024 | Blog",
      image: assets.blogthumb2,
      description:
        "In a major step towards advancing climate action, Australia’s House of Representatives has passed the Treasury Laws...",
    },
    {
      id: 4,
      title:
        "Tracy’s Odyssey: Navigating ESG Regulations and Building Sustainable Supply Chains with AccelESG",
      subtitle: "by admin | Apr 18, 2024 | Blog",
      image: assets.blogthumb3,
      description:
        "A few years ago, I was asked to moderate a Next Generation Oil and Gas panel entitled The Race to Net Zero, which...",
    },
    {
      id: 5,
      title:
        "How Can Carbon Accounting Help Companies Meet Emissions Standards?",
      subtitle: "by admin | Nov 3, 2023 | Blog",
      image: assets.blogthumb4,
      description:
        "Climate Leadership Most businesses have understood the importance of Environmental, Social, and Governance (ESG)...",
    },
    {
      id: 6,
      title:
        "ESG Integration in Energy Management: Leveraging Sustainability for Long-Term Success",
      subtitle: "by admin | Nov 3, 2023 | Blog",
      image: assets.blogthumb5,
      description:
        "In today's world, it is impossible to overestimate the significance of sustainability and ethical business practices....",
    },
    {
      id: 7,
      title: "Energy Management Best Practices for Sustainable Growth",
      subtitle: "by admin | Nov 3, 2023 | Blog",
      image: assets.blogthumb6,
      description:
        "Energy management with environmental consciousness and sustainable business practices has emerged as a critical aspect...",
    },
    {
      id: 8,
      title:
        "Leveraging Sustainable Supply Chain Operations for Competitive Advantage",
      subtitle: "by admin | Nov 3, 2023 | Blog",
      image: assets.blogthumb7,
      description:
        "In recent years, sustainability has emerged as a critical driver of success. Organizations recognize the importance of...",
    },
    {
      id: 9,
      title:
        "The Importance Of Corporate Social Responsibility In Green Finance",
      subtitle: "by admin | Oct 27, 2023 | Blog",
      image: assets.blogthumb8,
      description:
        "As global awareness of environmental issues continues to increase, there is a growing need for sustainable solutions...",
    },
    {
      id: 10,
      title: "A Comprehensive Guide To Green Insurance Products",
      subtitle: "by admin | Oct 26, 2023 | Blog",
      image: assets.blogthumb9,
      description:
        "A Comprehensive Guide To Green Insurance Products Sustainability has become critical, especially in the face of rapid...",
    },
    {
      id: 11,
      title:
        "How to Embed Sustainability into Your Digital Transformation Strategy",
      subtitle: "by admin | Oct 26, 2023 | Blog",
      image: assets.blogthumb10,
      description:
        "Hello for Action “Amid climate changes, there is an urgency for us to drive greater interest and accountability for...",
    },
    // {
    //   id: 11,
    //   title: "What is ESG and why is it important for Businesses and Investors",
    //   subtitle: "by admin | Oct 26, 2023 | Blog",
    //   image: blogthumb11,
    //   description:
    //     "What is ESG and why is it important for Businesses and Investors? Why ESG is important to Businesses and Investors? In...",
    // },
  ];

  return (
    <div>
      <div className="innerbanner-section-1">
        <div className="relative-2">
          <div className="s2-heading-text">
            <h1 data-aos="zoom-in">
              Voices from the Frontier of Climate Innovation
            </h1>
            <p data-aos="zoom-in">
              Dive into stories, breakthroughs, and bold ideas shaping the
              future of sustainability. From regenerative agriculture and
              AI-driven ESG to grassroots climate resilience, our blog
              chronicles the pulse of a planet in transition — one innovation,
              one community, one solution at a time.
            </p>
          </div>
          <img
            src={assets.careerbanner}
            alt=""
            data-aos="fade-in"
            className="d-d"
          />
          <img
            src={assets.careerbanner2}
            alt=""
            data-aos="fade-in"
            className="m-d"
          />
        </div>
      </div>
      <div className="flagship-bg">
        <div className="wrapper">
          <div class="flagship-heading">
            <h2>Latest Blogs</h2>
            {/* <p>
              From drylands to data platforms, our breakthrough initiatives
              showcase how scalable climate engineering is driving real-world
              transformation.
            </p> */}
          </div>
          <div className="blog-sec">
            {blogs.map((blog) => (
              <div key={blog.id} className="blog-m-item">
                <Link to={`/blog/${blog.id}`} onClick={scrollToTop}>
                  <img src={blog.image} alt={blog.title} />
                  <div className="blog-content">
                    <h4>{blog.title}</h4>
                    <h5>{blog.subtitle}</h5>
                    <p>{blog.description}</p>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Blogs;
